import { CartLinesUpdateEvent } from '@shopify/events';

// Kitch sepet çekmecesi: set yükseltme ve "+ Ekle" butonları (snippets/kitch-sepet-alt.liquid). Essental kalıbı.
// Sepeti güncelledikten sonra çekmeceyi, ürün kutusundaki sepete ekleme ile aynı olayla yeniletir.
const kok = () => window.Shopify?.routes?.root || '/';
const bolumler = () => [...document.querySelectorAll('cart-items-component')].map((e) => e.dataset.sectionId).filter(Boolean);

async function guncelle(btn, istek) {
  const hata = btn.closest('.ks-alt')?.querySelector('[data-ks-hata]');
  if (hata) hata.hidden = true;
  btn.disabled = true;
  const ertelenen = CartLinesUpdateEvent.createPromise();
  btn.dispatchEvent(new CartLinesUpdateEvent({ action: btn.closest('cart-drawer-component') ? 'update' : 'add', context: btn.closest('cart-drawer-component') ? 'cart' : 'product', lines: [], promise: ertelenen.promise }));
  try {
    const yanit = await istek(bolumler().join(','));
    const sepet = await fetch(`${kok()}cart.js`).then((r) => r.json());
    const detail = { items: sepet.items, source: 'kitch-sepet', itemCount: sepet.item_count, sections: yanit.sections, didError: Boolean(yanit.status) };
    ertelenen.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(sepet), detail });
    if (yanit.status && hata) { hata.textContent = yanit.description || 'Sepet güncellenemedi, tekrar dene.'; hata.hidden = false; }
  } catch (e) {
    ertelenen.reject(e);
    if (hata) { hata.textContent = 'Bağlantı sorunu oldu, tekrar dene.'; hata.hidden = false; }
  } finally {
    btn.disabled = false;
  }
}

const post = (yol, govde) => fetch(`${kok()}${yol}`, {
  method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(govde),
}).then((r) => r.json());

document.addEventListener('click', (e) => {
  const t = e.target instanceof Element ? e.target : null;
  const ekle = t?.closest('[data-ks-ekle]');
  if (ekle) {
    e.preventDefault();
    guncelle(ekle, (sections) => post('cart/add.js', { items: [{ id: Number(ekle.dataset.varyant), quantity: 1 }], sections }));
    return;
  }
  const yuksel = t?.closest('[data-ks-yukselt]');
  if (yuksel) {
    e.preventDefault();
    guncelle(yuksel, async (sections) => {
      // önce yeni seti ekle; başarılıysa eski satırı sil (ekleme düşerse müşterinin tavası sepette kalır)
      const eklendi = await post('cart/add.js', { items: [{ id: Number(yuksel.dataset.varyant), quantity: 1 }] });
      if (eklendi.status) return eklendi;
      return post('cart/change.js', { id: yuksel.dataset.satir, quantity: 0, sections });
    });
  }
});
